import './scss/app.scss';

// Atoms
import Select from '../styleguide/components/Atoms/Select';
// Molecules
import ArticleHeader from '../styleguide/components/Molecules/ArticleHeader';
import Carousel from '../styleguide/components/Molecules/Carousel';
import ContactForm from '../styleguide/components/Molecules/ContactForm';
import Drawer from '../styleguide/components/Molecules/Drawer';
import Filters from '../styleguide/components/Molecules/Filters';
import MainHeader from '../styleguide/components/Molecules/MainHeader';
import Modal from '../styleguide/components/Molecules/Modal';
import Popin from '../styleguide/components/Molecules/Popin';
import ServiceHeader from '../styleguide/components/Molecules/ServiceHeader';
import Slider from '../styleguide/components/Molecules/Slider';
import SocialShare from '../styleguide/components/Molecules/SocialShare';
import VehicleHeader from '../styleguide/components/Molecules/VehicleHeader';
import VehicleInfos from '../styleguide/components/Molecules/VehicleInfos';
import VehicleSpec from '../styleguide/components/Molecules/VehicleSpec';
// Organisms
import Comparator from '../styleguide/components/Organisms/Comparator';
import Header from '../styleguide/components/Organisms/Header';
import HeroHeader from '../styleguide/components/Organisms/HeroHeader';
import HeroVehicle from '../styleguide/components/Organisms/HeroVehicle';
import Map from '../styleguide/components/Organisms/Map';
// Utils
import SVGInjector from '../styleguide/utils/injector';

// Inject Sprite.svg
SVGInjector({
  source: '/assets/sprite.svg',
});

/**
 * Firefox/Gecko workaround for position: sticky bug
 * When elements receive focus or selection changes, sticky positioning can break
 */
const initFirefoxStickyFix = () => {
  const isFirefox = navigator.userAgent.toLowerCase().includes('firefox') ||
    navigator.userAgent.toLowerCase().includes('gecko/');

  if (!isFirefox) {
    return;
  }

  const header = document.querySelector('.header-wrapper');

  if (!header) {
    return;
  }

  const forceRepaint = () => {
    requestAnimationFrame(() => {
      header.style.transform = 'translateZ(0)';
      requestAnimationFrame(() => {
        header.style.transform = '';
      });
    });
  };

  // Listen for focus changes
  document.addEventListener('focusin', forceRepaint);
  document.addEventListener('focusout', forceRepaint);

  // Listen for selection changes
  document.addEventListener('selectionchange', forceRepaint);
};

initFirefoxStickyFix();

Carousel();
MainHeader();
ServiceHeader();
ArticleHeader();
Modal();
Popin();
Drawer();
VehicleHeader();
Select();
Filters();
VehicleInfos();
VehicleSpec();
Comparator();
ContactForm();
Header();
HeroHeader();
await Map();
HeroVehicle();
SocialShare();
Slider();
